<template src="./Placeholders.html"></template>
<style lang="scss" src='./Placeholders.scss' scoped ></style>

<script>
export default {
  props: {
    placeType: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
